import React, {useState, useContext, useRef} from 'react';
import { ReactDOM } from 'react';

import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonFooter } from '@ionic/react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export function ClockIn_ClockOut_Modal (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [tracker, setTracker] = useState('null');

    function clockIn(enteredPassword)
    {

        alert('In ClockIn');

        //let formData = new FormData();
        //formData.append('Tracker', props.tracker);
        //formData.append('xCompanySchema', 'bluefin_6569');
        //formData.append('xEnterEmployeePassword', enteredPassword);

        //let formData = new FormData();
        //formData.append('Tracker', props.tracker);
        //formData.append('xCompanySchema', 'bluefin_6569');
        //formData.append('xEnterEmployeePassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                xCompanySchema: 'bluefin_6569',
                xEnterEmployeePassword: enteredPassword,
                sessionID: sessionID,

            }),
            //body: formData,
            contentType: false,
            processData: false,        
        }



        fetch(baseURL+'merchants_argsApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function clock_in_handler(event) {
        setShowPasswordModal(event[0]);
        setTracker(event[1]);
    }

    function clock_out_handler(event) {
        setShowPasswordModal(event[0]);
        setTracker(event[1]);
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        alert('In onSubmitPasswordHandler');
        alert(enteredPassword);

        //setEnteredPassword(event);
        clockIn(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
    <React.Fragment>

{props.openModal == true ?
            (

                <IonModal isOpen={ props.openModal }>

                    <IonContent className='appGridContent'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='6'>
                                    <IonButton onClick={() => clock_in_handler([true, '74000in'])}> Clock-In </IonButton>
                                </IonCol>

                                <IonCol size='6'>
                                    <IonButton onClick={() => clock_out_handler([true, '74000out'])}> Clock-Out </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                        <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>

                    </IonContent>

                    <IonFooter className='appFooter'>
                        <IonButton onClick={() => props.closeModal(false)}>Cancel </IonButton>
                    </IonFooter>

                </IonModal>            
            ) : null }

    </React.Fragment>
    )
}